export default __webpack_public_path__ + "static/media/010-excercise.6aab3310.svg";